import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setAuthorizeRoot = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_AUTHORIZE_ROOT
            });

            if (data.status === 'success') {
                localStorage.setItem('rootToken', data.token);
                dispatch(Action.SetAuthorizeAction(true));
                dispatch(Action.SetAdminAction(data.admin));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setAuthorizeRoot as SetAuthorizeRoot
}